import { MigrationManifest } from 'redux-persist';
import { types as api } from '@mesa-labs/mesa-api';
import { PaginationLimits } from '../slices/invoices';

export const migrations: MigrationManifest = {
  // redux-persist does not have the correct generic types
  // to allow correct typing of our state tree here with
  // PersistedState
  0: (state: any) => ({
    ...state,
    ui: {
      ...state.ui,
      activeDashboardTableTab: 'payments',
    },
  }),
  1: (state: any) => ({
    ...state,
    ui: {
      ...state.ui,
      brand: 'jll',
    },
  }),
  2: (state: any) => ({
    ...state,
    ui: {
      ...state.ui,
      showGetPaidNowModal: false,
      showInstantPayoutTooltip: true,
    },
  }),
  3: (state: any) => ({
    ...state,
    ui: {
      ...state.ui,
      autologinDemo: undefined,
    },
  }),
  4: (state: any) => ({
    ...state,
    ui: {
      ...state.ui,
      showRequestInFlightsNotification: false,
      showRequestInFlightsModal: false,
    },
  }),
  5: (state: any) => ({
    ...state,
    ui: {
      ...state.ui,
      showFeedbackUI: true,
    },
  }),
  6: (state: any) => ({
    ...state,
    ui: {
      ...state.ui,
      getPaidNowInterstitialClickTimestamps: [],
    },
  }),
  7: (state: any) => ({
    ...state,
    ui: {
      ...state.ui,
      getPaidNowInterstitialClickTimestamps: [],
    },
  }),
  8: (state: any) => ({
    ...state,
    ui: {
      ...state.ui,
      demoMode: undefined,
    },
  }),
  9: (state: any) => ({
    ...state,
    onboarding: {
      ...state.onboarding,
      instantPayoutAlwaysOn: false,
    },
  }),
  10: (state: any) => ({
    ...state,
    modals: {
      ...state.modals,
      showAutoGetPaidNowPaymentRequestTotal: '',
      showAutoGetPaidNowWasRedirected: false,
    },
  }),
  11: (state: any) => ({
    ...state,
    onboarding: {
      ...state.onboarding,
      skipAutoInstantPayoutStep: false,
    },
  }),
  12: (state: any) => ({
    ...state,
    ui: {
      ...state.ui,
      singleToBulkInterstitialClickTimestamps: [],
    },
  }),
  13: (state: any) => ({
    ...state,
    ui: {
      ...state.ui,
      singleToBulkInterstitialClickTimestamps: [],
    },
  }),
  14: (state: any) => ({
    ...state,
    onboarding: {
      ...state.onboarding,
      promoCode: undefined,
    },
  }),
  15: (state: any) => ({
    ...state,
    ui: {
      ...state.ui,
      showEarlyPaymentOpportunitiesGlobalNotification: true,
    },
  }),
  16: (state: any) => ({
    ...state,
    invoices: {
      ...state.invoices,
      selectiveGetPaidNowRows: [],
    },
  }),
  17: (state: any) => ({
    ...state,
    invoices: {
      ...state.invoices,
      limit: {
        key: '10',
        value: 10,
      },
      invoices: [],
      page: 1,
      sortField: 'eligibleAt',
      selectiveGetPaidNowRows: [],
    },
  }),
  18: (state: any) => ({
    ...state,
    invoices: {
      ...state.invoices,
      invoices: [],
      page: 1,
      limit: PaginationLimits[0],
      total: undefined,
      searchTerm: undefined,
      startDate: undefined,
      endDate: undefined,
      sortField: 'eligibleAt',
      sortDirection: api.SortDirection.DESCENDING,
      exportFormat: api.CsvFormat.MESA_CSV_FORMAT,
      exportFormatType: 'vendor',
      excludeStates: [],
      displayState: undefined,
      instantPayoutId: undefined,
      mesaOnDemandId: undefined,
      selectiveGetPaidNowRows: [],
    },
  }),
  19: (state: any) => ({
    ...state,
    ui: {
      ...state.ui,
      invoiceSummaryOpen: true,
      discoverMoreOpen: true,
    },
  }),
  20: (state: any) => ({
    ...state,
    modals: {
      ...state.modals,
      showUploadInvoiceDocumentModal: false,
      uploadInvoiceDocumentModalInvoiceId: undefined,
    },
  }),
  21: (state: any) => ({
    ...state,
    ui: {
      ...state.ui,
      payEarlyButtonClickCount: 0,
    },
  }),
  22: (state: any) => ({
    ...state,
    invoices: {
      ...state.invoices,
      // must reset this to [] so that selectiveGetPaidNowTotal is initially in sync
      selectiveGetPaidNowRows: [],
      selectiveGetPaidNowTotal: 0,
    },
  }),
  23: (state: any) => ({
    ...state,
    advancedFilters: {
      ...state.advancedFilters,
      statuses: [],
      clientIds: [],
    },
  }),
  24: (state: any) => ({
    ...state,
    advancedFilters: {
      ...state.advancedFilters,
      statuses: [],
      clientIds: [],
      totalOpenAmountOperator: ">=",
      estimatedPaymentDateOperator: ">=",
    },
  }),
  25: (state: any) => {
    // Clean up orphaned nested persist key after removing nested persistReducer
    // for vendor
    localStorage.removeItem('persist:vendor');
    return state;
  },
  26: (state: any) => ({
    ...state,
    invoices: {
      ...state.invoices,
      selectiveGetPaidNowRowsMetadata: {},
    },
  }),
  27: (state: any) => ({
    ...state,
    ui: {
      ...state.ui,
      factoringBannerDismissed: false,
    },
  }),
  28: (state: any) => ({
    ...state,
    factoringApplication: {
      customers: [],
      portals: [],
      volume: null,
    },
  }),
  29: (state: any) => ({
    ...state,
    ui: {
      ...state.ui,
      factoringReviewBannerDismissed: false,
    },
  }),
  30: (state: any) => ({
    ...state,
    ui: {
      ...state.ui,
      factoringPortalSetupBannerDismissed: false,
    },
  }),
  31: (state: any) => ({
    ...state,
    factoringPortalSetup: {
      portals: [],
      selectedPortalId: null,
    },
  }),
  32: (state: any) => ({
    ...state,
    factoringPortalSetup: {
      ...state.factoringPortalSetup,
      selectedStepId: null,
    },
  }),
  // factoringApplication and factoringPortalSetup are no longer persisted local
  // state — both are now derived from the real factoring API.
  33: (state: any) => {
    const { factoringApplication, factoringPortalSetup, ...rest } = state;
    return rest;
  },
  // Replaced by lastCompletedStep, which scopes the mark to an email. In-flight vendors
  // lose their local high-water mark and re-seed from the server on the next step.
  34: (state: any) => {
    const { lastCompletedStepStage, ...onboarding } = state.onboarding || {};
    return { ...state, onboarding };
  },
  // The credit memos tab and slice were renamed to adjustments.
  35: (state: any) => {
    const { creditMemos, ...rest } = state;
    const migrated = creditMemos && !rest.adjustments ? { ...rest, adjustments: creditMemos } : rest;
    if (migrated.ui?.activeDashboardTableTab === 'creditMemos') {
      return { ...migrated, ui: { ...migrated.ui, activeDashboardTableTab: 'adjustments' } };
    }
    return migrated;
  },
  // Selections persisted before the gross total existed would show a net-only banner total
  36: (state: any) => ({
    ...state,
    invoices: {
      ...state.invoices,
      selectiveGetPaidNowRows: [],
      selectiveGetPaidNowRowsMetadata: {},
      selectiveGetPaidNowTotal: 0,
      selectiveGetPaidNowGrossTotal: 0,
    },
  }),
};
